<template>
    <div id="ReportEmployeeTypes">
      <div v-if="this.filterView">
        <MdTitle v-bind:Text="$t('employeeType.EmplTypeTitle')" />
        <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="SearchEmployeeTypes"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="SearchEmployeeTypes">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <b-row>
        
          <b-col lg="6" md="6" sm="12">
              <MdEdit
                  v-bind:Label="$t('Shared.Description')"
                  v-model="employeeType.employeeType" 
                />
          </b-col>
        </b-row> 
        <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdCheckBox
                v-bind:Label="$t('employeeType.ShowInNotes')"
                v-bind:Name="'showinNotes'"
                v-bind:ClassProp="'AlignCheck'"
                v-bind:CheckedValue="true"
                v-bind:UncheckedValue="false"
                v-model="EmployeeType.showInNotes"
            />
          </b-col> 
          
          <b-col md="3" lg="3" sm="12" >
            <MdCheckBox
                v-bind:Label="$t('employeeType.InternalType')"
                v-bind:Name="'checkbox-InternalType'"
                v-bind:ClassProp="'AlignCheck'"
                v-bind:CheckedValue="true"
                v-bind:UncheckedValue="false"
                 v-model="EmployeeType.systemType"
              />
          </b-col>
          <b-col md="3" lg="3" sm="12" >
            <MdCheckBox
                v-bind:Label="$t('employeeType.IsProvider')"
                v-bind:Name="'checkbox-IsProvider'"
                v-bind:ClassProp="'AlignCheck'"
                v-bind:CheckedValue="true"
                v-bind:UncheckedValue="false"
                v-model="EmployeeType.provider"
              />
          </b-col>
          <b-col md="3" lg="3" sm="12" >
            <MdCheckBox
                v-bind:Label="$t('employeeType.IsNurse')"
                v-bind:Name="'checkbox-IsNurse'"
                v-bind:ClassProp="'AlignCheck'"
                v-bind:CheckedValue="true"
                v-bind:UncheckedValue="false"
                v-model="EmployeeType.nurse"
                v-bind:isReadOnly=this.$route.params.isSystemType
              />
          </b-col>
          <b-col lg="3" md="3" sm="12"></b-col>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="SearchEmployeeTypes"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col>
        </b-row>
        
        <div class="row">
          <div class="col-md-12">
            <MdTitle v-bind:Text="$t('Shared.SearchResult')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            <div class="row">
              <div class="col-md-12">
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    v-bind:IsViewListAllergies="true"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction">
                  </MdTable>
                </div>
            </div>
          </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>   
        
          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>
        </div>
      </div>
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('employeeType.EmployeeTypesReport')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="EmployeeType"
          :ReportName="'EmployeeType'"
          :ReportTitle="$t('employeeType.EmployeeTypesReport')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('employeeType.EmplTypeTitle')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/EmployeeTypes/exportCSV'"
    >    
    </CSVExportHelper>
  </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import PatientService from '@/services/patient.service';
    import Utils from '../../../common/utils'
    import AllergyService from '@/services/allergies.service'
    import AllergyProblemSeveritiesService from '@/services/allergiesproblemseverities.service'
    import DBFunctions from '@/common/DBFunctions.js'
    import { EventBus } from '@/event-bus.js'; 

export default Vue.extend({
    name: "EmployeeTypeRep",
    mixins: [ ShowMessage, DBFunctions ],
    components: { DxPopup },
    props: {
      patientCode: String,
      closeWindow: Function,
      recNo: String,
      patientName: String,
      filterView: Boolean
    },
    data() {
      
        return {
          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,
              PatientCode:'',
              Mode:this.edit_mode,
              favButtonAtion:false          
          },
          isParamVisible: true,
          isReportVisible: false,
          reportParams: [],
          params: {
          
          },
        
          parameter:{
            Status: true,
            SearchCriteria:'',
            PageNumber : 0,
            PageSize:0,
          },
          ShowMessageIsEmpty:true,
          fields: [
            { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'hidden'},       
            { key: 'description', sortable: true, label: this.$t('Shared.Name'), class: 'text-rigth' }, 
            { key: 'systemType', sortable: true, label: this.$t('employeeType.InternalType'), class: 'text-rigth' },
            { key: 'showInNotes', sortable: true, label: this.$t('employeeType.ShowInNotes'), class: 'text-rigth' },   
            { key: 'provider', sortable: true, label: this.$t('employeeType.IsProvider'), class: 'text-rigth' },   
            { key: 'nurse', sortable: true, label: this.$t('employeeType.IsNurse'), class: 'text-rigth' },   
          ],

          pageOptions: [5, 10, 15 ],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          items: [],
          selected: [],
          Header:{},
          refTable: 'selectableTable',
          EmployeeType:{
            descrition:"",
            showInNotes:false,
            systemType: false  ,
            provider:false,
            nurse:false    
          },
          dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',               
        }
    },
    methods: {

        onShowing(e) {
          let contentElement = e.component.content();
          let titleElement = e.component._$title[0]
          contentElement.style.padding = '0px';
          titleElement.style.padding = '0px 20px'
        },

        onHiddenReport() {
          this.isReportVisible = false
          if(!this.filterView)
            this.closeWindow();
        },

        onClickClose() {
          this.closeWindow()
          this.isParamVisible = false;
        },

        initializeParameters() {
          this.parameter.AllergyCodeList = this.params.AllergyCodeList && this.params.AllergyCodeList !== ''
            ? this.params.AllergyCodeList
            : null;
          this.parameter.PatientCodeList = this.params.PatientCodeList && this.params.PatientCodeList !== ''
              ? this.params.PatientCodeList
              : null;
          this.parameter.PageNumber = this.currentPage;
          this.parameter.PageSize = this.perPage;
          this.parameter.PatientCode = this.patientCode;
          this.parameter.PatientIsActive = (this.params.IsActive === 'all') ? null : this.params.IsActive;
          this.parameter.ActiveAdmission = (this.params.IsActiveAdmission === 'all') ? null : this.params.IsActiveAdmission;
          this.parameter.IsActive = (this.params.Show === 'all') ? null : this.params.Show;
          this.parameter.DateFrom = this.dateFrom;
          this.parameter.DateTo = this.dateTo;
          this.parameter.Severity = this.Allergy.problemSeverity;
        },

        initializePdfParameters() {
          this.reportParams = []

          this.reportParams.push({ paramName: 'pRecNo', paramValue: this.recNo})
          this.reportParams.push({ paramName: 'pRepName', paramValue: this.$t('employeeType.EmplTypeTitle')})
          this.reportParams.push({ paramName: 'pDescription',paramValue: this.EmployeeType.descrition})
          this.reportParams.push({ paramName: 'pSystemType', paramValue:this.EmployeeType.systemType })
          this.reportParams.push({ paramName: 'pShowInNotes', paramValue: this.EmployeeType.showInNotes})
          this.reportParams.push({ paramName: 'pProvider', paramValue: this.EmployeeType.provider})
          this.reportParams.push({ paramName: 'pNurse', paramValue: this.EmployeeType.nurse})
          this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
        },

        onClickShowReport() {
          this.initializePdfParameters();
          this.isParamVisible = false
          this.isReportVisible = true
          this.$refs.EmployeeType.buildDocument(this.reportParams)
        },

        ChangeDropDownPatients(values) {
          this.params.PatientCodeList = [];
          values.forEach(it => {
            this.params.PatientCodeList.push(it.patientcode)
          });
          
          // this.params.PatientCodeList = this.getItemsByComma(values, 'patientcode')
        },

        customLabelPatients ({ patientName, patientcode }) {
          return `${patientName} – ${patientcode}`
        },

        getPatients() {              
          PatientService.getPatientList(this.parameter)
            .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.PatientsList = response.data; 
              this.PatientsList.forEach(function(element) {
                  element.patientName = element.firstname + " " + element.lastname;   
                });
              }      
            })
        },
        reportList() {
            this.checkExistFavorite('/app/reports/patients');
            this.$router.push({ name: "reportListPatient" }).catch(()=>{});
        },
        getItemsByComma(values, field) {
          let len = values.length;
          let valuesSeparated = [];
          if (len > 0){
            var i = 0;
            values.forEach(function(e) {   
              if(i < len-1){
                valuesSeparated += e[field]+",";
              }else{
                valuesSeparated += e[field];
              }
              i++;                    
            });
            return valuesSeparated;
          } else {
            return [];
          }
      },

      getAllergiesProblemSeverities(){
        AllergyProblemSeveritiesService.getAll()
          .then((response) => {
              if(response.status == '200' && response.data){
                this.AllergySeverity = response.data;
              }
          })
      },

      getAllergies() { 
        AllergyService.getAll(this.parameter)
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.AllergiesList = response.data;
            }
          })
      },
      ChangeDropDownAllergySeverity(value){
          this.Allergy.problemSeverity = value ? value.description : '';
      },

      ChangeDropDownAllergies(values){
          this.params.AllergyCodeList = this.getItemsByComma(values, 'allergyCode')
      },
      customLabelAllergy ({ allergy }) {
          return `${allergy}`
      },
      ChangeShow(item) {
        this.params.Show = item.value
      },
      async loadContents() {
          await this.getAllergiesProblemSeverities();
          await this.getAllergies();
         
      },
      ChangeIsActive(item) {
        this.params.IsActive = item.value
      },
      ChangeIsActiveAdmission(item) {
        this.params.IsActiveAdmission = item.value
      },
      SearchEmployeeTypes(){
        this.Loading = true;
        this.$emit('load', this.Loading);
        this.items = [];
        this.currentPage = 1;
        this.parameter.PageNumber = 1;
        this.totalRows = this.items.length;
        this.getTableAllergies();
     
      },
      pageChanged (page) {            
       this.currentPage = page;
       this.getTableAllergies();    
      },

      PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.getTableAllergies();
      },

      onRowSelected(items) {    
      this.selected = items;
      },

      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
      ,
      getTableAllergies() {
        this.parameter.PageNumber = this.currentPage;
        this.parameter.PageSize = this.perPage; 
        this.initializeParameters();

        AllergyService.getAll(this.parameter, true)
          .then((response) => {
            this.ShowMessageIsEmpty = false;
            if(response.status == '200' && response.data && response.data.length > 0){
              this.items = response.data;
              this.items.forEach(function(element) {
                  if (element.patientDOB)	
                    element.patientDOB = Utils.formatterDateToString(element.patientDOB); 
                });
              let headerString = response.headers["x-pagination"];
              this.Header = JSON.parse(headerString);
              this.totalRows = this.Header.TotalCount;
            }
            if(this.items.length === 0){
              this.ShowMessageIsEmpty = true;
            }
            this.Loading = false;
            this.$emit('load', this.Loading);
          })
          .catch(error => {
            this.Loading = false;
            this.$emit('load', this.Loading);
            if (!error.response) {
                // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
            } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        });
    },
    
    handleCSV(action) {
      this.initializeParameters();
      switch(action) {
        case 'export':
          this.$refs.csvExportHelper.exportCSV(this.parameter);
        break;
        case 'email':
          this.$refs.csvExportHelper.emailCSV(this.parameter);
        break;
        default:
          console.warn('unknow action:', action);
        break;
      }
    },

    handlePdf(action) {
      this.initializePdfParameters();
      switch(action) {
        case 'export':
          this.$refs.csvExportHelper.exportToPdf('PatientAllergy', true, false, this.reportParams);
        break;
        case 'email':
          this.$refs.csvExportHelper.emailPdf('PatientAllergy', true, false, this.reportParams);
        break;
        default:
          console.warn('unknow action:', action);
        break;
      }
    },
  },

  created() {
    
  },
  mounted () {
    
    if(!this.filterView) {
        this.onClickShowReport();
    } else {
      this.getPatients(); 
      this.loadContents()
      this.OptionsRightMenu.ItemsList = [];
      let layoutStatus = this.$store.state.layoutStatus;
      switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }
    }

    EventBus.$on("ShowWeel", function (isShow) { 
        isShow ? this.$emit('load', true) : this.$emit('load', false);     
     }.bind(this));
  },
})
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
